
import { defineComponent, computed } from 'vue';
import TagKeyValueManageMenu from '@/components/Domain.Tags/TagKeyValueManageMenu.vue';
import { useTenantStore, useDatasetState } from '@/stores/tenant';

export default defineComponent({
    components: { TagKeyValueManageMenu },
    props: {
        me: Object,
        value: Object,
        loading: Boolean,
    },
    setup() {
        const tab: string = null;
        const tenantStore = useTenantStore();
        const tabs = computed(() => {
            const { hasUsageDataset, hasEmissionsDataset } = useDatasetState(tenantStore);
            return [
                hasUsageDataset ? { key: 'usage', icon: 'insights', text: 'views.dialogTag.tabs.usage' } : null,
                hasUsageDataset ? { key: 'trends', icon: 'compare_arrows', text: 'views.dialogTag.tabs.trends' } : null,
                hasEmissionsDataset ? { key: 'carbon', icon: 'co2', text: 'views.dialogTag.tabs.carbon' } : null,
            ].filter((t) => t);
        });
        return { tab, tabs, tenantStore };
    },
    computed: {
        tagName() {
            return (this.value?.tagKeyValue ?? "...").replace("(Blanks)","<Untagged>");
        }
    }
});
